import { render, staticRenderFns } from "./SwiperHome.vue?vue&type=template&id=bc188020&scoped=true&"
import script from "./SwiperHome.vue?vue&type=script&lang=js&"
export * from "./SwiperHome.vue?vue&type=script&lang=js&"
import style0 from "./SwiperHome.vue?vue&type=style&index=0&id=bc188020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc188020",
  null
  
)

export default component.exports